export const COVERAGE_ENDPOINTS = {
  BASE: "/v1/coverage",
  /** Chapitres d'une case (ossature + importés). */
  OSSATURE_CHAPTERS: "/v1/ossature/chapters",
} as const;
